import { createFileRoute } from "@tanstack/react-router";
import AdminAiTokens from "@/pages/admin/AdminAiTokens";

export const Route = createFileRoute("/admin/consumo-ia")({ component: AdminAiTokens });
